<div class="min-h-screen bg-white flex flex-col">
  <div class="flex-1 container mx-auto max-w-[900px] px-5 py-12">
    <h1 class="text-3xl font-semibold text-gray-800 mb-8">Terms of Use</h1>

    <div class="prose prose-gray max-w-none">
      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Acceptance of Terms</h2>
        <p class="text-gray-600 mb-4">
          This website belongs to Vertical Bridge and its affiliates. By accessing this site, you agree to be bound by these Terms of Use. Any claim relating to the use of this website is governed by the laws of the state of Florida.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Access</h2>
        <p class="text-gray-600 mb-4">
          Users may access, download, or print materials for personal use in planning or managing your specific projects or other purposes as offered.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Availability</h2>
        <p class="text-gray-600 mb-4">
          While Vertical Bridge attempts to keep the website available, we provide no guarantee of continuous service or freedom from interruptions.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Conduct</h2>
        <p class="text-gray-600 mb-4">
          Users must not damage servers, post unlawful or harmful content, transmit malware, access restricted areas, or re-publish, re-transmit or otherwise incorporate materials from this website in any document.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Change Notice</h2>
        <p class="text-gray-600 mb-4">
          VB may modify, change, update or replace the terms of use in whole or in any part at any time.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Limitation of Liability</h2>
        <p class="text-gray-600 mb-4">
          USE OF THIS WEBSITE IS AT YOUR OWN RISK. The company disclaims responsibility for losses or damages and provides the site "AS IS, WHERE IS, WITH ALL FAULTS" without warranties.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Arbitration Agreement</h2>
        <p class="text-gray-600 mb-4">
          Disputes must be resolved through binding arbitration with the American Arbitration Association rather than court proceedings.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Class Action Waiver</h2>
        <p class="text-gray-600 mb-4">
          Users waive rights to pursue claims as part of class actions, agreeing to individual arbitration only.
        </p>
      </section>

      <section class="mb-8">
        <h2 class="text-xl font-semibold text-gray-800 mb-4">Text Messaging</h2>
        <p class="text-gray-600 mb-4">
          Users may opt into text messages and can opt out by replying "STOP" to messages.
        </p>
      </section>
    </div>

    <div class="mt-12 pt-8 border-t border-gray-200">
      <a routerLink="/home" class="text-[#8BC540] hover:underline">&larr; Back to Home</a>
    </div>
  </div>

  <app-footer />
</div>
